<p-toast position="top-center"></p-toast>
@if (showCurrentPasswordDialog) {
<div class="message-selection">
  <div class="logo-container">
    <img class="logo-img" src="assets/icons/logo.png" alt="logo" />
  </div>
  <div style="display: flex">
    <i class="pi pi-chevron-left chevron-left" (click)="closePopup()" style="cursor: pointer; padding: 10px"></i>
    <h3 class="styled-text">enter your current password</h3>
  </div>
  <div class="message-options">
    <div class="textarea-container">
      <div class="password-wrapper">
        <input id="currentPassword" class="input-field" pInputText [type]="showCurrentPassword ? 'text' : 'password'"
          placeholder="current password" [(ngModel)]="currentPassword" />
        <i [class]="showCurrentPassword ? 'pi pi-eye-slash' : 'pi pi-eye'" class="password-icon"
          (click)="toggleCurrentPasswordVisibility()"></i>
      </div>
    </div>
  </div>
  <div style="display: flex; justify-content: center;">
    <button class="send-btn" (click)="verifyCurrentPassword()">continue</button>
  </div>
</div>
} @else {
  <div class="message-selection">
    <div class="logo-container">
      <img class="logo-img" src="assets/icons/logo.png" alt="logo" />
    </div>
    <div style="display: flex">
      <i class="pi pi-chevron-left chevron-left" (click)="closePopup()" style="cursor: pointer; padding: 10px"></i>
      <h3 class="styled-text">enter your new password</h3>
    </div>
    <div class="message-options">
      <div class="message-options">
        <div class="textarea-container">
          <div class="password-wrapper">
            <input id="password" class="input-field" pInputText [type]="showPassword ? 'text' : 'password'"
              placeholder="new password" [(ngModel)]="password" />
            <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'" class="password-icon"
              (click)="togglePasswordVisibility()">
            </i>
          </div>
        </div>

        <div class="textarea-container">
          <div class="password-wrapper">
            <input id="reenter" class="input-field" pInputText [type]="showRePassword ? 'text' : 'password'"
              placeholder="re-enter" [(ngModel)]="reenter" />
            <i [class]="showRePassword ? 'pi pi-eye-slash' : 'pi pi-eye'" class="password-icon"
              (click)="toggleRePasswordVisibility()">
            </i>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex;justify-content: center;">
      <button class="send-btn" (click)="Continue()">continue</button>
    </div>
  </div>
}
<p-dialog [(visible)]="showConfirmation" [modal]="true" [closable]="false" [showHeader]="false"
  styleClass="custom-confirm-dialog password-saved-dialog">
  <div class="message-selection">
    <h3>password saved</h3>
    <div>woo! you got yourself new password</div>
    <div style="display: flex; justify-content: center">
      <button class="send-btn" (click)="closeConfirmation()">ok</button>
    </div>
  </div>
</p-dialog>